// import * as classNames from "classnames";
import * as React from "react";
// import * as Classes from "../";

import "./styles.css";

import { HTMLDivProps } from "@blueprintjs/core";

interface IMPDFrostedGlassProps extends HTMLDivProps {
  focus?: boolean;
}

interface IMPDFrostedGlassState {
  contentContainerHeight?: number;
}

export class MPDFrostedGlass extends React.Component<
  IMPDFrostedGlassProps,
  IMPDFrostedGlassState
> {
  public static defaultProps: HTMLDivProps = {
    placeholder: "Filler Placeholder"
  };

  constructor(props: HTMLDivProps) {
    super(props);
    this.state = {
      contentContainerHeight: 0
    };
  }

  public render() {
    // const { className } = this.props;
    // const classes = classNames(Classes.FROSTED_GLASS_CONTAINER, className);

    return (
      <div>
        <svg
          id="svg1"
          viewBox="0 0 100 70"
          height="70%"
          width="70%"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <filter
              xmlns="http://www.w3.org/2000/svg"
              id="dropshadow"
              height="180%"
            >
              <feGaussianBlur in="SourceAlpha" stdDeviation={5} />
              <feOffset dx="0.2" dy="0.2" result="offsetblur" />
              <feMerge>
                <feMergeNode />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <filter id="blurFilter" x={0} y={0}>
              <feGaussianBlur stdDeviation="0.5" />
            </filter>
            <pattern
              id="Pattern"
              width="100%"
              height="100%"
              x={0}
              y={0}
              patternUnits="userSpaceOnUse"
            />
            <pattern
              id="blurPattern"
              width="100%"
              height="100%"
              x={0}
              y={0}
              patternUnits="userSpaceOnUse"
            >
              <image
                width="100%"
                height="100%"
                y={-2}
                xlinkTitle="asdasdsdsada"
                filter="url(#blurFilter)"
              />
            </pattern>
          </defs>
          {/* Background and overlay */}
          <rect
            className="background_rect"
            x={0}
            y={0}
            width="100%"
            height="100%"
            stroke="rgba(250,250,250,0.3)"
            strokeWidth="0.1px"
            fill="url(#Pattern)"
          />
          <rect
            className="overlay_rect"
            x={12}
            y={5}
            width="35%"
            height="83%"
            fill="url(#blurPattern)"
            rx={1}
            ry={1}
          />
          <rect
            className="overlay_rect_rgba"
            x={12}
            y={5}
            width="35%"
            height="83%"
            fill="rgba(250, 250, 250, 0.3)"
            stroke="rgba(250, 250, 250, 0.8)"
            strokeWidth="0px"
            rx={1}
            ry={1}
          />
          {/* Overlay inner styling */}
          <text
            x={30}
            y={10}
            width={30}
            fill="black"
            textAnchor="middle"
            style={{ fontSize: 5 }}
          >
            <tspan className="sub_title" x={30} dy={3}>
              Tomme de
            </tspan>
            <tspan className="title" x={30} dy="7.5" height={10}>
              Savoie
            </tspan>
            <tspan className="content" x={30} dy={7}>
              Cheese lorem ipsum dolor
            </tspan>
            <tspan className="content" x={30} dy={3}>
              sit Tomme de Savoie amet
            </tspan>
            <tspan className="content" x={30} dy={3}>
              savoyard adipiscing elit,
            </tspan>
            <tspan className="content" x={30} dy={3}>
              sed cheese eiusmod tempor
            </tspan>
            <tspan className="content" x={30} dy={3}>
              incididunt ut labore et
            </tspan>
            <tspan className="content" x={30} dy={3}>
              fromages magna aliqua.
            </tspan>
          </text>
          <g className="button">
            <rect
              x="17.5"
              y={48}
              width="25%"
              height="11%"
              fill="none"
              stroke="#56362e"
              strokeWidth="0.1px"
              rx={1}
              ry={1}
            />
            <text x={30} y={53} fill="black" textAnchor="middle">
              Discover
            </text>
          </g>
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mpd-library/frosted-glass/frosted-glass.tsx